import { render, staticRenderFns } from "./TaskOptions.vue?vue&type=template&id=ebd54bc8&scoped=true&"
import script from "./TaskOptions.vue?vue&type=script&lang=js&"
export * from "./TaskOptions.vue?vue&type=script&lang=js&"
import style0 from "./TaskOptions.vue?vue&type=style&index=0&id=ebd54bc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd54bc8",
  null
  
)

export default component.exports